import { ComponentType as p } from "../../registries/types/propTypes.js";
const l = (s) => {
  var r;
  const a = [], t = Array.isArray(s.amway_promises) ? s.amway_promises[0] : s.amway_promises;
  return (r = t == null ? void 0 : t.images) == null || r.forEach((o) => {
    const m = o.title, i = o.images.images.map((e) => ({
      url: e.image.url,
      altText: e.alt_text,
      viewport: e.viewport
    }));
    a.push({
      imageTitle: m,
      imagesData: i
    });
  }), {
    componentType: p.amway_promises,
    title: t.display_title,
    ourPromisesdata: a
  };
};
export {
  l as default
};
//# sourceMappingURL=our-promises-transformer.js.map
